import useSWRMutation from 'swr/mutation';
import { useSession } from '@packages/utilities';
import { useIntl } from 'react-intl';

type Key = [string, string];

type ToggleServiceProductArgs = {
  sku: string;
  pli: string;
};

type ToggleServiceProductResponse = any;

const toggleServiceProduct =
  (locale: string) =>
  (
    [url, token]: Key,
    {
      arg,
    }: {
      arg: ToggleServiceProductArgs;
    },
  ): Promise<ToggleServiceProductResponse> =>
    fetch(url, {
      method: 'PUT',
      headers: { 'x-ec-token': token, 'ec-locale': locale, 'Content-Type': 'application/json' },
      body: JSON.stringify(arg),
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`Toggle service product: Status ${res.status}: ${res.statusText}`);
      }
      return res.json();
    });

export const useToggleServiceProduct = () => {
  const { locale } = useIntl();
  const { jwtToken } = useSession();

  const {
    trigger,
    data: toggleServiceProductData,
    error,
    isMutating,
  } = useSWRMutation(
    jwtToken ? ['/api/checkout/v1/toggleServiceProduct', jwtToken] : null,
    toggleServiceProduct(locale),
  );

  return { trigger, toggleServiceProductData, error, isMutating };
};
